<div class="page-header">
    <div class="col-12">
        <h1>Bonus Table <small>View expected bonus progress</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="4">
            <a ngbNavLink>Bonus Table</a>
        </li>
        <li [ngbNavItem]="5">
            <a ngbNavLink>Bonus Table Inputs</a>
        </li>
        <li [ngbNavItem]="6">
            <a ngbNavLink>Bonus Progress</a>
        </li>
    </ul>

    <div style="margin-top: 10px" [hidden]="active !== 4">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <grid-export [grid]="gridBonus" [name]="'Job Scheduling'"></grid-export>
                    <wj-combo-box
                        [(ngModel)]="selectedYear"
                        name="selectedYear"
                        (ngModelChange)="refreshBonus()"
                        [itemsSource]="yearMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="gridBonus"
                    #gridBonus
                    appAutoSize
                    [padding]="73"
                    (initialized)="bonusGrid.initialize(gridBonus)"
                    [itemsSource]="bonusGrid.view"
                    [keyActionTab]="'CycleEditable'"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="' '" [binding]="'metric'" [width]="'1.5*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'90% PLAN'" [binding]="'plan90'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'95% PLAN'" [binding]="'plan95'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'PLAN'" [binding]="'plan'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 2'" [binding]="'level2'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 3'" [binding]="'level3'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 4'" [binding]="'level4'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 5'" [binding]="'level5'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 6'" [binding]="'level6'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 7'" [binding]="'level7'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 8'" [binding]="'level8'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                </wj-flex-grid>
                <grid-selection-calculation [grid]="gridBonus"></grid-selection-calculation>
            </div>
        </div>
    </div>
    <div style="margin-top: 10px" [hidden]="active !== 5">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="bonusInputGrid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="bonusInputGrid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <grid-export [grid]="gridBonusInput" [name]="'Job Scheduling'"></grid-export>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="gridBonusInput"
                    #gridBonusInput
                    appAutoSize
                    [padding]="73"
                    (initialized)="bonusInputGrid.initialize(gridBonusInput)"
                    [itemsSource]="bonusInputGrid.view"
                    [keyActionTab]="'CycleEditable'"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Year'" [binding]="'year'" [width]="'*'" [format]="'d'"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Plan Percent'"
                        [binding]="'planPercent'"
                        [format]="'P2'"
                        [width]="'*'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Bonus Pool Percent'"
                        [binding]="'bonusPoolPercent'"
                        [format]="'P2'"
                        [width]="'*'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Overhead'" [binding]="'overhead'" [format]="'C0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Plan'" [binding]="'plan'" [format]="'C0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Extra'" [binding]="'extra'" [format]="'C0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Other Income'"
                        [binding]="'otherIncome'"
                        [format]="'C0'"
                        [width]="'*'"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
                <grid-selection-calculation [grid]="gridBonusInput"></grid-selection-calculation>
            </div>
        </div>
    </div>
    <div style="margin-top: 10px" [hidden]="active !== 6">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <wj-input-date
                        [(ngModel)]="gaugeDate"
                        name="gaugeDate"
                        (ngModelChange)="refresh()"
                        [selectionMode]="'Month'"
                        [format]="'M/d/yyyy'"
                    ></wj-input-date>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <h2 style="text-align: center">Actual Gross Margin {{ currentYear }}</h2>
                <wj-radial-gauge
                    #gauge
                    [min]="0"
                    [max]="120"
                    [isReadOnly]="true"
                    [value]="progress"
                    [showText]="'None'"
                    [startAngle]="-45"
                    [sweepAngle]="270"
                    [tickSpacing]="20"
                    [needleShape]="'Pointer'"
                    [needleLength]="'Outer'"
                    [thickness]="0.3"
                    [showTicks]="true"
                    [showTickText]="true"
                    [showRanges]="true"
                >
                    <wj-range [min]="ranges[0]" [max]="ranges[1]" [color]="'#92ff92'"></wj-range>
                    <wj-range [min]="ranges[1]" [max]="ranges[2]" [color]="'#6fe16f'"></wj-range>
                    <wj-range [min]="ranges[2]" [name]="'blaj'" [max]="ranges[3]" [color]="'#4fc14f'"></wj-range>
                    <wj-range [min]="ranges[3]" [max]="ranges[4]" [color]="'#319f31'"></wj-range>
                    <wj-range [min]="ranges[4]" [max]="ranges[5]" [color]="'#1d871d'"></wj-range>
                    <wj-range [min]="ranges[5]" [max]="ranges[6]" [color]="'#0b680b'"></wj-range>
                    <wj-range [min]="ranges[6]" [max]="ranges[7]" [color]="'#004e00'"></wj-range>
                    <wj-range [min]="ranges[7]" [max]="120" [color]="'#013801'"></wj-range>
                </wj-radial-gauge>
                <h4 style="text-align: center">{{ progress | number: '1.2-2' }}% of Level 1 (100%)</h4>
                <h4 style="text-align: center">Reach Level 8 at {{ ranges[7] | number: '1.2-2' }}%!</h4>
                <br />
                <h4 style="text-align: center">
                    Actual GM as of {{ gaugeDate | date: 'shortDate' }} {{ currentYearTotalActualProfit | currency }}
                </h4>
            </div>
            <div class="col-4">
                <h2 style="text-align: center">Actual + Projected Gross Margin {{ currentYear }}</h2>
                <wj-radial-gauge
                    [min]="0"
                    [max]="120"
                    [value]="progress2"
                    [showText]="'None'"
                    [startAngle]="-45"
                    [sweepAngle]="270"
                    [tickSpacing]="20"
                    [needleShape]="'Pointer'"
                    [needleLength]="'Outer'"
                    [thickness]="0.3"
                    [showTicks]="true"
                    [showTickText]="true"
                    [showRanges]="true"
                >
                    <wj-range [min]="ranges[0]" [max]="ranges[1]" [color]="'#92ff92'"></wj-range>
                    <wj-range [min]="ranges[1]" [max]="ranges[2]" [color]="'#6fe16f'"></wj-range>
                    <wj-range [min]="ranges[2]" [max]="ranges[3]" [color]="'#4fc14f'"></wj-range>
                    <wj-range [min]="ranges[3]" [max]="ranges[4]" [color]="'#319f31'"></wj-range>
                    <wj-range [min]="ranges[4]" [max]="ranges[5]" [color]="'#1d871d'"></wj-range>
                    <wj-range [min]="ranges[5]" [max]="ranges[6]" [color]="'#0b680b'"></wj-range>
                    <wj-range [min]="ranges[6]" [max]="ranges[7]" [color]="'#004e00'"></wj-range>
                    <wj-range [min]="ranges[7]" [max]="120" [color]="'#013801'"></wj-range>
                </wj-radial-gauge>
                <h4 style="text-align: center">{{ progress2 | number: '1.2-2' }}% of Level 1 (100%)</h4>
                <h4 style="text-align: center">Reach Level 8 at {{ ranges[7] | number: '1.2-2' }}%!</h4>
                <br />
                <h4 style="text-align: center">Projected GM {{ projectedProfit | currency }}</h4>
            </div>
            <div class="col-4">
                <h2 style="text-align: center">Projected Gross Margin {{ currentYear + 1 }}</h2>
                <wj-radial-gauge
                    [min]="0"
                    [max]="120"
                    [value]="nextYearProgress"
                    [showText]="'None'"
                    [startAngle]="-45"
                    [sweepAngle]="270"
                    [tickSpacing]="20"
                    [needleShape]="'Pointer'"
                    [needleLength]="'Outer'"
                    [thickness]="0.3"
                    [showTicks]="true"
                    [showTickText]="true"
                    [showRanges]="true"
                >
                    <wj-range [min]="ranges[0]" [max]="ranges[1]" [color]="'#92ff92'"></wj-range>
                    <wj-range [min]="ranges[1]" [max]="ranges[2]" [color]="'#6fe16f'"></wj-range>
                    <wj-range [min]="ranges[2]" [max]="ranges[3]" [color]="'#4fc14f'"></wj-range>
                    <wj-range [min]="ranges[3]" [max]="ranges[4]" [color]="'#319f31'"></wj-range>
                    <wj-range [min]="ranges[4]" [max]="ranges[5]" [color]="'#1d871d'"></wj-range>
                    <wj-range [min]="ranges[5]" [max]="ranges[6]" [color]="'#0b680b'"></wj-range>
                    <wj-range [min]="ranges[6]" [max]="ranges[7]" [color]="'#004e00'"></wj-range>
                    <wj-range [min]="ranges[7]" [max]="120" [color]="'#013801'"></wj-range>
                </wj-radial-gauge>
                <h4 style="text-align: center">{{ currentYear + 1 }} Projected GM {{ nextYearGP | currency }}</h4>
            </div>
        </div>
    </div>
</div>
<style>
    .wj-gauge {
        margin: 2em auto;
        padding: 5% 12%;
    }

    .wj-gauge .wj-needle {
        fill: orangered;
        stroke: orangered;
    }

    .wj-gauge .wj-needle .wj-inner-needle-cap {
        fill: white;
    }
</style>
